/*
  * @Author: zql
  * @Date: 2025/1/10 17:41
*/

import router,{notFindRoutes,constantRoutes} from './router'
import store from './store'
import NProgress from 'nprogress' // progress bar
import 'nprogress/nprogress.css' // progress bar style
import {getIsLogin,removeIsLogin,getToken} from '@/utils/auth' // get token from cookie
import getPageTitle from '@/utils/get-page-title';
import  matomo from '@/utils/matomo'
import _ from 'lodash'
import { MessageBox } from 'element-ui'

NProgress.configure({showSpinner: false});

// '/login','/bind',
const whiteList = ['/auc', '/test']; // no redirect whitelist

// 首屏引导失败重试间隔：跨过后端 AUC 刷新锁的 pending 窗口（实测约 400~600ms）
const BOOTSTRAP_RETRY_DELAY = 800;

const isAuthError = (error) => {
    const code = Number(error && error.code);
    return code === 401 || code === 407 || code === 419;
};

// 首屏引导失败时给出可见反馈，避免导航被中止后整页纯白
const handleBootstrapError = (error) => {
    NProgress.done();
    // 401/407/419 已由 ajax.js 弹出重新登录/跳转，不重复提示
    if (isAuthError(error)) {
        return;
    }
    const message = (error && error.info) || '页面加载失败，请重试';
    MessageBox.confirm(message, '提示', {
        confirmButtonText: '重试',
        cancelButtonText: '关闭',
        type: 'error',
        closeOnClickModal: false,
        closeOnPressEscape: false,
    }).then(() => {
        window.location.reload();
    }).catch(() => {});
};

// 首屏引导：拉取用户信息 + 生成并注入动态路由（失败时由守卫重试一次）
const bootstrapUserAndRoutes = async () => {
    const routeExists = router.getRoutes();
    const {navigation} = await store.dispatch('user/getUserInfo');
    const accessRoutes = await store.dispatch('permission/generateRoutes', navigation);
    accessRoutes.concat(notFindRoutes).forEach(item => {
        if (!routeExists.some(route => route.path === item.path)) {
            router.addRoute(item);
        }
    });
    const {team_name, name, position} = store.state.user;
    matomo.setUserId(`${name}_${team_name}_${position}`);
    matomo.setCustomVariable(1, '部门', team_name);
    matomo.setCustomVariable(2, '岗位', position);
};

router.beforeEach( async (to, from, next) => {
    NProgress.start();
    const title = getPageTitle(to.meta.title);
    document.title = title;
    const hasUserId = store.getters.user_id;
    if (whiteList.indexOf(to.path) !== -1) {
        next()
    }else if(from.query.sub_uid&&!to.query.sub_uid){
        if(to.path===from.path){
            to.query.t= new Date().getTime();
        }
        router.push({
            name:to.name,
            query:Object.assign({},to.query,{sub_uid:from.query.sub_uid}),
            params:to.params
        });
    }else if(to.query.sso_authorize_code){
        /* 没有token*/
        let sso_authorize_code = to.query.sso_authorize_code;
        // 在auc页面登录成功后，会跳回原页面，携带sso参数
        let res_sso = '';
        if(Array.isArray(sso_authorize_code) && sso_authorize_code.length>0) {
            res_sso = sso_authorize_code[sso_authorize_code.length-1];
        }else{
            res_sso = sso_authorize_code;
        };
          // 用最新的sso请求AUC
        try {
            await store.dispatch('user/getAUC',{
                sso_authorize_code:res_sso,
                // to_path:window.location.pathname,
            });
        } catch (error) {
            handleBootstrapError(error);
            return;
        }
        next({
            ...to,
            query: _.omit(to.query, ['sso_authorize_code']) 
        })
    }else if (!hasUserId){
        try {
            await bootstrapUserAndRoutes();
        } catch (error) {
            // 首次失败（如 AUC 刷新锁 pending / 服务抖动）间隔后重试一次
            await new Promise(resolve => setTimeout(resolve, BOOTSTRAP_RETRY_DELAY));
            try {
                await bootstrapUserAndRoutes();
            } catch (retryError) {
                handleBootstrapError(retryError || error);
                return;
            }
        }
        next({...to, replace: true})
    }else {
        next()
    }
});

router.afterEach((to, form) => {
    matomo.setCustomUrl(`${to.fullPath}`)
    matomo.trackPageView(`${ _.map(to.matched,(v)=>v.meta.title).join(' -> ')}`)
    NProgress.done()
});




